let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '移动端管理'
    },
    {
        type: 'title',
        name: '消息设置'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'messageId',
    editRouter: 'messageDetail',
};

// 路由
pageConfig.listRouter = 'messageList';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '移动端管理',
    },
    {
        type: 'router',
        name: '消息设置',
        router: 'messageList'
    },
    {
        type: 'title',
        name: '消息详情',
    },
];

pageConfig.formRules = {
    messageType: [{
        required: true,
        message: '请选择消息类型',
        trigger: 'change'
    }],
    messageStatus:[
        {
            required: true,
            message: '请选择消息名称',
            trigger: 'change'
        }
    ],
    messageRemark: [
        {
            required: true,
            message: '请填写消息文案',
            trigger: 'blur'
        }
    ],
    sendStatus:[
        {
            required: true,
            message: '请选择发送机制',
            trigger: 'change'
        }
    ]
};



export default pageConfig;